import { getColor } from 'common/constants/_colors';
import { StyledMultiLinesChart } from 'components/MultiLinesChart/MultiLinesChart.style';
import { WhiteSection } from 'components/base/layout-components';
import styled from 'styled-components';

export const StyledSubHeader = styled.header`
  color: ${getColor('shuttleGray')};
  font-size: 1.2rem;
  margin-bottom: 2rem;
`;

export const StyledListWrapper = styled.main``;

export const StyledCategoryItem = styled.div`
  border-bottom: 1px solid ${getColor('catskillWhite')};
  border-top: 1px solid ${getColor('catskillWhite')};
  display: flex;
  align-items: center;
  width: 97%;
  padding: 2.5rem 1rem;

  &.isSelected {
    background-color: ${getColor('catskillGray')};
  }
  &.isClickable {
    &:hover {
      background-color: ${getColor('catskillGray')};
      border-bottom-color: ${getColor('pigeonPost')};
      border-top-color: ${getColor('pigeonPost')};
      cursor: pointer;
    }
  }

  & > main {
    width: 90%;
    & > header {
      margin-bottom: 0.5rem;
    }
  }
  & > aside {
    margin-left: auto;
    margin-right: -2rem;
    & svg#ChevronRight {
      width: 4rem;
      height: 4rem;
      margin-right: 1rem;
    }
  }
`;

export const StyledCategoriesList = styled.div`
  & ${WhiteSection} {
    height: 100%;
  }
  & ${StyledMultiLinesChart} {
    width: 100%;
  }
`;
